import { shallowEqual, useSelector } from 'react-redux';

export const useDrawerHistoryNavigation = () => {
  const lastGames = useSelector((state: any) => state.app.lastGames, shallowEqual);
  return {
    lastGames,
  };
};
